import React, { memo, useEffect } from 'react';
import { Layout } from '../styles/Hero.styles';
import Footer from '../util/Footer';
import Hero from './Hero';
import Cities from './Cities';
import CleaningTypes from './CleaningTypes';
import Easy123 from './Easy123';
import FAQs from './FAQs';
import GetStarted from './GetStarted';
import Neighborhoods from './Neighborhoods';
import Reviews from './Reviews';

interface LocationPageProps {
  city: string;
}

function LocationPage(props: LocationPageProps) {
  const city = props.city === 'New York' ? 'nyc' : props.city.toLowerCase();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout style={{ background: '#fff' }}>
      <Hero city={props.city} />
      <Easy123 />
      <CleaningTypes />
      {city === 'nyc' ? <Cities /> : <Reviews />}
      {city !== 'nyc' && <Neighborhoods city={props.city} />}
      <FAQs city={city as 'nyc' | 'brooklyn' | 'manhattan' | 'queens'} />
      <GetStarted />
      <Footer {...props} />
    </Layout>
  );
}

export default memo(LocationPage);
